import Vue from 'vue'
import i18n from '../i18n'

const printFile = (type, title, bookTitle, items) => {
  let content = '',
    url = window.location.toString(),
    blank = window.open(url, '_blank'),
    doc = blank.document

  if (type === 'notes') {
    items.forEach(item => {
      content = `${content}<br><h4>${item.quote}</h4><p>${item.text}</p><p class="italic">s. ${item.page}, ${Vue.filter('formatDate')(item.created)}</p>`
    })
  }
  if (type === 'highlights') {
    items.forEach(item => {
      content = `${content}<br><h4>${item.quote}</h4><p class="italic">s. ${item.page}, ${Vue.filter('formatDate')(item.created)}</p>`
    })
  }

  doc.open()
  doc.write(
    `<html>
    <head>
    <title>${bookTitle}</title>
    <style>
    body {margin: 10px 20px; color: #333; font: 16px/1.6 Arial,sans-serif}
    body > h1 {margin: 30px 0; font-size: 26px; line-height: 1.2}
    body > h4 {margin: 5px 0; font-size: 16px; line-height: 1.2}
    body > p {margin: 5px 0; font-size: 16px; line-height: 1.2}
    .italic {font-style: italic}
    </style>
    </head>
    <body>
    <h1> ${title} | ${bookTitle} | ${i18n.t('DBOK_READER')}</h1>${content}
    </body>
    </html>`
  )
  doc.close()
  blank.print()
  blank.close()
}

export default printFile